import { matchPath } from 'react-router';
import { SFF_MENU_ITEMS, GP_MENU_ITEMS } from '../../constants';
import { LocationItem, Menu, MerchantItem } from '../../interface';
import { getNavBarItems } from './getNavBarItems';

export const checkIfRouteExists = (route: string, isMerchant = false, isSquareNavEnabled = false, options = { exact: true, strict: false }): boolean => {
  const MENU_ITEMS = isSquareNavEnabled ? SFF_MENU_ITEMS : GP_MENU_ITEMS;

  return (isMerchant ? MENU_ITEMS.MERCHANT : MENU_ITEMS.LOCATION).some((menu: Menu<MerchantItem | LocationItem> | MerchantItem | LocationItem) =>
    getNavBarItems(menu).some((item) => matchPath(route, { path: item.link, ...options })),
  );
};
